import { Languages } from '@frontend/common';
import { Dropdown, DropdownItem } from '@frontend/components/common';

import useLanguageSelect from './language-select.controller';

interface LanguageSelectProps {
    className?: string;
    itemClassName?: string;
}

export const LanguageSelect = (props: LanguageSelectProps) => {
    const viewProps = useLanguageSelect();

    return (
        <Dropdown
            buttonStyle='h-10 px-4 bg-background-surface rounded-full border border-border-default inline-flex justify-start items-center gap-2 overflow-hidden'
            label={Languages.find((l) => l.value === viewProps.currentLocale)?.shortDisplayName || viewProps.currentLocale}>
            {viewProps.options?.map((lang) => {
                return (
                    <DropdownItem
                        key={lang.value}
                        label={lang.displayName}
                        onClick={() => viewProps.onClick(lang)}
                        className={props.itemClassName}
                    />
                );
            })}
        </Dropdown>
    );
};

export default LanguageSelect;
